import { render, staticRenderFns } from "./meritFactor.vue?vue&type=template&id=11acf4f6&scoped=true&"
import script from "./meritFactor.vue?vue&type=script&lang=js&"
export * from "./meritFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11acf4f6",
  null
  
)

export default component.exports